var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","margin-top":"-20px","margin-left":"-20px"},attrs:{"id":"iframe1"}},[_c('iframe',{attrs:{"frameborder":"0","align":"middle","src":"https://helihong.xiedeqingxdq.com/tree/","width":"100%","height":"100%","scrolling":"no"}})])
}]

export { render, staticRenderFns }